interface HomeHeaderProps {
  userName: string;
  adaptiveMessage: string;
}

const HomeHeader = ({ userName, adaptiveMessage }: HomeHeaderProps) => {
  return (
    <div className="pt-1">
      <h1 className="text-2xl font-heading font-bold">¡Hola, {userName}! 👋</h1>
      <p className="text-sm text-muted-foreground mt-1 leading-relaxed">{adaptiveMessage}</p>
    </div>
  );
};

export default HomeHeader;
